import { createAction } from 'redux-actions';
import { ExchangeRefundModalData } from '@entities/order';

export const SET_REFUND_SERVICES_SELECTED_PRODUCT_IDS = 'REFUND_SERVICES/SET_SELECTED_PRODUCT_IDS';
export const SET_REFUND_SERVICES_LOADING = 'REFUND_SERVICES/SET_LOADING';
export const SET_REFUND_SERVICES_MODAL = 'REFUND_SERVICES/SET_MODAL';
export const CLOSE_REFUND_SERVICES_MODAL = 'REFUND_SERVICES/CLOSE_MODAL';

export const setRefundServicesSelectedProductIds = createAction<number[]>(SET_REFUND_SERVICES_SELECTED_PRODUCT_IDS);
export const setRefundServicesLoading = createAction<boolean>(SET_REFUND_SERVICES_LOADING);
export const setRefundServicesModal = createAction<ExchangeRefundModalData>(SET_REFUND_SERVICES_MODAL);
export const closeRefundServicesModal = createAction(CLOSE_REFUND_SERVICES_MODAL);

export type SetRefundServicesSelectedProductIdsAction = ReturnType<typeof setRefundServicesSelectedProductIds>;
export type SetRefundServicesLoadingAction = ReturnType<typeof setRefundServicesLoading>;
export type SetRefundServicesModalAction = ReturnType<typeof setRefundServicesModal>;
export type CloseRefundServicesModalAction = ReturnType<typeof closeRefundServicesModal>;

export type RefundServicesActionTypes =
	| SetRefundServicesSelectedProductIdsAction
	| SetRefundServicesLoadingAction
	| SetRefundServicesModalAction
	| CloseRefundServicesModalAction;
